import React from "react";
import { motion } from "framer-motion";

function WhyChooseUs() {
  const items = [
    {
      title: "Expert Team",
      description: "Our experienced professionals deliver reliable and scalable solutions.",
      icon: "ri-team-line",
      gradient: "from-purple-500 to-indigo-500",
    },
    {
      title: "Customer-Centric Approach",
      description: "We focus on understanding your goals to deliver tailored results.",
      icon: "ri-hand-heart-line",
      gradient: "from-pink-500 to-rose-500",
    },
    {
      title: "Innovative Solutions",
      description: "We use modern technology to create smart, future-ready products.",
      icon: "ri-lightbulb-flash-line",
      gradient: "from-yellow-500 to-orange-500",
    },
    {
      title: "Comprehensive Services",
      description: "From planning to execution — everything under one roof.",
      icon: "ri-service-line",
      gradient: "from-emerald-500 to-teal-500",
    },
    {
      title: "Proven Track Record",
      description: "A strong portfolio of successful projects across industries.",
      icon: "ri-trophy-line",
      gradient: "from-cyan-500 to-blue-500",
    },
    {
      title: "24/7 Support",
      description: "We provide round-the-clock assistance to ensure your success.",
      icon: "ri-headphone-line",
      gradient: "from-pink-500 to-purple-500",
    }
  ];

  return (
    <section className="relative py-28 px-6 md:px-16 overflow-hidden">
      <motion.h1 
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center text-5xl md:text-7xl font-bold mb-28 text-indigo-600"
      >
        Why <span className="text-secondary">Choose Us?</span>
      </motion.h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-28 gap-x-12">
        {items.map((item, index) => (
          <motion.div 
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            className="group relative bg-slate-950 backdrop-blur-xl border border-white/10 rounded-2xl p-10 text-center transition-all duration-500 hover:-translate-y-4 shadow-2xl"
          >
            <div className={`absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-30 bg-gradient-to-r ${item.gradient} blur-3xl transition-opacity duration-500 -z-10`}></div>
            <div className="absolute -top-10 left-0 right-0 flex justify-center">
               <motion.div
                  whileHover={{ rotate: 360, scale: 1.1 }}
                  transition={{ duration: 0.8, ease: "backInOut" }}
                  className={`w-20 h-20 rounded-full bg-gradient-to-r ${item.gradient} flex items-center justify-center text-white text-4xl shadow-2xl cursor-pointer relative`}
               >
                  <div className={`absolute inset-0 rounded-full bg-gradient-to-r ${item.gradient} animate-ping opacity-20`}></div>
                  <i className={`${item.icon} relative z-10`}></i>
               </motion.div>
            </div>

            <div className="mt-10 relative z-10">
              <h2 className="text-2xl font-bold mb-4 text-white tracking-tight">
                {item.title}
              </h2>
              <p className="text-gray-400 text-lg leading-relaxed font-light">
                {item.description}
              </p>
            </div>

            <div className={`absolute inset-0 rounded-2xl border border-white/0 group-hover:border-white/10 transition-all duration-500`}></div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default WhyChooseUs;